import getClosingDate from '~/src/lib/getClosingDate';
import isDisplayHeadbandOrder from '~/src/lib/isDisplayHeadbandOrder';
import getFilteredOrders from '~/src/lib/getFilteredOrders';

const getHeaderSpecialInfoHeight = (business, orders, router) => {
    const HEIGHT = 50;
    let h = 0;

    if (business) {
        const closingDate = getClosingDate(business);
        if (closingDate) {
            h = h + HEIGHT;
        }

        const todayOrder = getFilteredOrders(orders, {
            today: true,
            status: 'not_delivered',
        });

        if (isDisplayHeadbandOrder(business, orders, router) === true) {
            h = h + HEIGHT;
        }
    }

    return h;
};

export default getHeaderSpecialInfoHeight;
